import { useLayoutEffect, useState } from 'react';
export const useHeaderKey = () => {
    const [key, setKey] = useState(() => Date.now());
    useLayoutEffect(() => {
        setKey(Date.now()); // force re-render to update header styles
    }, []);
    return key;
};
